<template>
  <div class="status">
    <div class="status-div">
      <label class="status-label">{{
        $t('template_list.status_filter_label')
      }}</label>
    </div>
    <div class="status-field">
      <md-field>
        <md-select
          v-model="selectedStatuses"
          class="multi-select"
          multiple
          :placeholder="$t('template_list.status_filter_all')"
          @md-selected="updateStatuses"
        >
          <md-option
            v-for="option in options"
            :key="option.value"
            :value="option.value"
          >
            {{ option.label }}
          </md-option>
        </md-select>
      </md-field>
    </div>
  </div>
</template>

<script>
import isEqual from 'lodash/isEqual';

export default {
  name: 'filter-status',
  emits: ['update'],
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    statuses: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedStatuses: [],
    };
  },
  watch: {
    statuses(newVal) {
      this.selectedStatuses = [...newVal];
    },
  },
  created() {
    this.selectedStatuses = [...this.statuses];
  },
  methods: {
    updateStatuses() {
      if (!isEqual(this.statuses, this.selectedStatuses)) {
        this.$emit('update', [...this.selectedStatuses]);
      }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.status {
  display: inline-flex;
  float: right;
  height: 100%;
  width: 100%;
}

.status-div {
  margin: auto;
  height: 100%;
  width: 100%;
}

.status-label {
  text-align: right;
  margin-right: 16px;
  margin-top: 16px;
  padding-right: 16px;
  height: 100%;
  width: 100%;
  color: #363636 !important;
  display: block;
  font-size: 1rem !important;
  font-weight: 600;
}

.multi-select {
  margin: auto;
  height: 100%;
  margin-right: 10px;
  margin-left: 10px;
  margin-top: -10px;
}
</style>
